import { API_CONFIG, getNodeApiHeaders } from '../helpers/constants';

interface EncryptSecretResponse {
  encryptedSecret: string;
}

export async function encryptSecretForStorage(secret: string): Promise<string> {
  const response = await fetch(`${API_CONFIG.NODE_BASE_URL}/rest/oauth/encrypt-secret`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getNodeApiHeaders(),
    },
    body: JSON.stringify({ secret }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || `Secret encryption failed: ${response.status}`);
  }

  const data = await response.json() as EncryptSecretResponse;
  if (!data.encryptedSecret) {
    throw new Error('Secret encryption failed: empty ciphertext returned');
  }

  return data.encryptedSecret;
}
